<template>
    <div class="page">
        <div class="wrapper">
            <div class="intake-form">
                <h2>Intake</h2>
                <div class="intake-nav">
                    <div :class="{'active' : activeTab === 'personalia', 'activated' : activatedStep('personalia')}"
                         @click="gotoPage('personalia')"><span class="btn">Personalia</span><span class='gt'>&gt;</span>
                    </div>
                    <div :class="{'active' : activeTab === 'looks', 'activated' : activatedStep('looks')}"
                         @click="validateForm('personalia', 'looks')"><span class="btn">Looks</span><span class='gt'>&gt;</span>
                    </div>
                    <div :class="{'active' : activeTab === 'misc', 'activated' : activatedStep('misc')}"
                         @click="validateForm('looks', 'misc')"><span class="btn">Overig</span><span class='gt'>&gt;</span></div>
                    <div :class="{'active' : activeTab === 'photos', 'activated' : activatedStep('photos')}"
                         @click="gotoPage('photos')"><span class="btn">Foto’s</span><span class='gt'>&gt;</span></div>
                    <div :class="{'active' : activeTab === 'finish', 'activated' : activatedStep('finish')}"
                         @click="gotoPage('finish')"><span class="btn">Afronden</span></div>
                </div>
                <div>
                    <button id="personalia" :class="{'intake-nav-btn-mobile': true, 'active' : activeTab === 'personalia', 'activated' : activatedStep('personalia')}" @click.prevent="gotoPage('personalia')">Personalia
                    </button>
                    <div :class="{'open' : activeTab === 'personalia', 'step-wrapper': true}">
                        <personalia :isValidated="isValidated['personalia']" scope="personalia"></personalia>
                        <span class="btn btn-orange" @click.prevent="validateForm('personalia', 'looks')">Volgende stap</span>
                    </div>

                    <button id="looks"
                            :class="{'intake-nav-btn-mobile': true, 'active' : activeTab === 'looks', 'activated' : activatedStep('looks')}" @click.prevent="gotoPage('looks')">Looks
                    </button>
                    <div v-show="activeTab === 'looks'">
                        <looks v-if="activatedStep('looks')" scope="looks"></looks>
                        <span class="btn btn-orange" @click.prevent="validateForm('looks', 'misc')">Volgende stap</span>
                    </div>

                    <button id="misc"
                            :class="{'intake-nav-btn-mobile': true, 'active' : activeTab === 'misc', 'activated' : activatedStep('misc')}"
                            @click.prevent="gotoPage('misc')">Overig
                    </button>

                    <div v-show="activeTab === 'misc'">
                        <misc v-if="activatedStep('misc')" scope="misc"></misc>
                        <span class="btn btn-orange"
                              @click.prevent="validateForm('misc', 'photos')">Volgende stap</span>
                    </div>

                    <button id="photos"
                            :class="{'intake-nav-btn-mobile': true, 'active' : activeTab === 'photos', 'activated' : activatedStep('photos')}"
                            @click.prevent="gotoPage('photos')">Photos
                    </button>

                    <div v-show="activeTab === 'photos'">
                        <photos v-if="activatedStep('photos')"></photos>
                        <div v-if="showNoofPhotosError" class="error-photos">
                            Je moet minimaal 4 fotos insturen!
                        </div>
                        <span class="btn btn-orange"
                              @click.prevent="validateForm('photos', 'finish')">Volgende stap</span>
                    </div>
                    <button id="finish"
                            :class="{'intake-nav-btn-mobile': true, 'active' : activeTab === 'finish', 'activated' : activatedStep('finish')}"
                            @click.prevent="gotoPage('finish')">Finish
                    </button>

                    <div v-show="activeTab === 'finish'">
                        <finish v-if="activatedStep('finish')"></finish>
                    </div>
                    <br><br><br><br><br>
                </div>
            </div>
        </div>
        <router-view></router-view>
    </div>
</template>
<script type='text/babel'>
    import Personalia from './Personalia.vue'
    import Looks from './Looks.vue'
    import Misc from './Misc.vue'
    import Photos from './Photos.vue'
    import Finish from './Finish.vue'

    export default {
        components: {
            Personalia,
            Looks,
            Misc,
            Photos,
            Finish,
        },
        data: () => ({
            activatedSteps: ['personalia'],
            showNoofPhotosError: false,
            isValidated: {},
            scopes: ['personalia', 'looks', 'misc']
        }),
        mounted() {
            if (this.activatedSteps.indexOf(this.activeTab) === -1) {
                document.location = "/"
            }
            this.$validator.localize('en');
        },
        computed: {
            activeTab() {
                return this.$store.getters.tab()
            },
            noofPhotos() {
                return this.$store.getters.noofPhotos()
            },
        },
        methods: {
            gotoPage(page) {
                if (page === 'finish' && this.noofPhotos < 4) {
                    this.showNoofPhotosError = true
                } else if (this.activatedStep(page)) {
                    this.showNoofPhotosError = false
                    this.$router.push({path: page})
                }
            },
            activatedStep(step) {
                return this.activatedSteps.indexOf(step) > -1
            },
            validateForm(currPage, nextPage) {
                this.$validator.validateAll(currPage).then(() => {
                    if (!this.errors.any()) {
                        this.activatedSteps.push(nextPage)
                        this.gotoPage(nextPage)
                    } else {
                        let firstField = this.errors.items[0].field
                        VueScrollTo.scrollTo('#' + firstField, 500, {offset: -90})
                    }
                });
            }
        },
    };
</script>
